export const PHYSICS_UPDATE_RATE = 1000 / 30;
